// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3o6Bz","title":"InfoRow_title__EtuwD"};